export enum Auth0Connection {
  Google = 'google-oauth2',
  Microsoft = 'windowslive',
  Authentication = 'Username-Password-Authentication',
}
